import React from 'react';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useBooking } from '../../modules/booking/BookingContext';

interface ActionButtonsProps {
  className?: string;
  location?: {
    state?: string;
    city?: string;
    area?: string;
  };
}

export default function ActionButtons({ className = '', location }: ActionButtonsProps) {
  const { pathname } = useLocation();
  const { bookingState, setBookingState } = useBooking();
  const isBookingPage = pathname === '/book';

  const handleBooking = () => {
    if (location) {
      setBookingState({
        ...bookingState,
        ...location
      });
    }
  };

  if (isBookingPage) return null;

  return (
    <div className={`flex flex-wrap items-center justify-center gap-4 ${className}`}>
      <Link
        to="/book"
        onClick={handleBooking}
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 shadow-sm"
      >
        <Calendar className="h-5 w-5 mr-2" />
        Book Now
      </Link>

      <a
        href="tel:+918559929954"
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 shadow-sm"
      >
        <Phone className="h-5 w-5 mr-2" />
        Call Now
      </a>

      <a
        href="https://wa.me/918559940369"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 hover:bg-blue-900 shadow-sm"
      >
        <MessageCircle className="h-5 w-5 mr-2" />
        WhatsApp
      </a>
    </div>
  );
}